import { useEffect, useState } from "react";
import MapView from "../components/MapView";
import ChartPanel from "../components/ChartPanel";
import { io } from "socket.io-client";
import { authFetch } from "../api";

const API = "https://tradeon.fi/api";

export default function Mobile(){

  const [devices,setDevices] = useState([]);
  const [history,setHistory] = useState([]);
  const [selected,setSelected] = useState(null);

  // 🔐 Require login
  useEffect(()=>{
    const token = localStorage.getItem("accessToken");
    if(!token){
      window.location.href="/";
    }
  },[]);

  // ================= INITIAL DEVICES =================
  useEffect(()=>{

    const load = async ()=>{
      try{
        const data = await authFetch(`${API}/devices`);
        setDevices(data || []);
      }catch{
        setDevices([]);
      }
    };

    load();

  },[]);

  // ================= HISTORY =================
  useEffect(()=>{

    if(!selected?.imei && !selected?.id) return;

    const id = selected.imei || selected.id;

    const load = async ()=>{
      try{
        const data = await authFetch(`${API}/history/${id}`);
        setHistory(data || []);
      }catch{
        setHistory([]);
      }
    };

    load();

  },[selected]);

  // ================= SOCKET =================
  useEffect(()=>{

    const socket = io("https://tradeon.fi",{
      path:"/socket.io/",
      transports:["websocket"],
      auth:{
        token:localStorage.getItem("accessToken")
      }
    });

    socket.on("connect",()=>{
      console.log("SOCKET CONNECTED");
    });

    socket.on("temp",(d)=>{

      setDevices(prev=>{

        const i = prev.findIndex(dev => (dev.imei||dev.id) === d.imei);

        if(i === -1){
          return [
            ...prev,
            {
              id:d.imei,
              imei:d.imei,
              name:d.imei,
              temp:d.temp,
              water:d.water,
              lat:d.lat,
              lng:d.lon
            }
          ];
        }

        const copy = [...prev];
        copy[i] = {
          ...copy[i],
          temp:d.temp,
          water:d.water ?? copy[i].water,
          lat:d.lat ?? copy[i].lat,
          lng:d.lon ?? copy[i].lng
        };

        return copy;
      });

      if(selected && (selected.imei||selected.id) === d.imei){
        setHistory(prev=>[
          ...prev,
          {time:d.time,temp:d.temp}
        ].slice(-300));
      }

    });

    return ()=>socket.disconnect();

  },[selected]);

return (
  <div style={{ height:"100vh", width:"100vw", background:"#000" }}>

    {/* YLÄ BANNER BAR */}
    <div style={{
      height:"90px",
      background:"#000",
      display:"flex",
      alignItems:"center",
      justifyContent:"center",
      borderBottom:"1px solid #222"
    }}>
      <a href="https://tradeon.fi/" target="_blank" rel="noopener noreferrer">
        <img
          src="/tradeon-banner.png"
          alt="Tradeon"
          style={{
            height:"60px",
            opacity:0.9
          }}
        />
      </a>
    </div>

    <div style={{ height:"calc(65vh - 90px)" }}>
      <MapView
        devices={devices}
        selected={selected}
        setSelected={setSelected}
      />
    </div>

    <div style={{ height:"35vh" }}>
      <ChartPanel history={history}/>
    </div>

  </div>
);
}